import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TableData = styled.td(() =>
  mq({
    textAlign: 'right',
  }),
);

export const Refunds = styled.div(() =>
  mq({
    '& > div:not(:last-child)': {
      borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    },
  }),
);

export const RefundWrapper = styled.div(() =>
  mq({
    padding: [
      `${defaultTheme.spacing.m} ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.m} ${defaultTheme.spacing.s}`,
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
    ],
  }),
);

export const HitNums = styled.div((props: { is4Two: boolean }) =>
  mq({
    display: props.is4Two ? 'grid' : 'flex',
    gridTemplateColumns: 'repeat(2, 52px)',
    gridGap: props.is4Two ? defaultTheme.spacing.s : 0,
    justifyContent: 'flex-end',
    span: {
      width: '18px',
      height: '18px',
      fontSize: '10px',
    },
    '& > span:not(:last-child)': {
      marginRight: '2px',
    },
  }),
);

export const AmountWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const HitCount = styled.span(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: defaultTheme.color.primary,
    fontWeight: 'bold',
    fontSize: defaultTheme.font.size.xs,
    backgroundColor: '#FFEE00',
    borderRadius: '16px',
    padding: `${defaultTheme.spacing.xs} ${defaultTheme.spacing.s}`,
  }),
);

export const Amount = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    fontWeight: 'bold',
    marginLeft: defaultTheme.spacing.xs,
  }),
);
